import { useCallback, useMemo, useState, createContext } from "react";

export const SidebarContext = createContext({
  sidebarToggle: false,
  toggleSidebar: () => {}
});

export const SidebarProvider = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);

  const toggleSidebar = useCallback(() => {
    setSidebarToggle((current) => !current);
  }, []);

  const value = useMemo(
    () => ({ sidebarToggle, toggleSidebar }),
    [sidebarToggle, toggleSidebar]
  );

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};
